// color design tokens export

export const tokensDark = {
  grey: {
    0: "#ffffff", // manually adjusted
    10: "#f6f6f6", // manually adjusted
    50: "#f0f0f0", // manually adjusted
    100: "#e0e0e0",
    200: "#c2c2c2",
    300: "#a3a3a3",
    400: "#858585",
    500: "#666666",
    600: "#525252",
    700: "#3d3d3d",
    800: "#292929",
    900: "#141414",
    1000: "#000000", // manually adjusted
  },
  primary: {
    // blue
    100: "#d3d4de",
    200: "#a6a9be",
    300: "#7a7f9d",
    400: "#4d547d",
    500: "#21295c",
    600: "#191F45", // manually adjusted
    700: "#141937",
    800: "#0d1025",
    900: "#070812",
  },
  secondary: {
    // Verde
    100: "#cce6e6",
    200: "#99cccc",
    300: "#66b3b3",
    400: "#339999",
    500: "#008080",
    600: "#006666",
    700: "#004d4d",
    800: "#003333",
    900: "#001a1a"
  },
  
};

// function that reverses the color palette
function reverseTokens(tokensDark) {
  const reversedTokens = {};
  Object.entries(tokensDark).forEach(([key, val]) => {
    const keys = Object.keys(val);
    const values = Object.values(val);
    const length = keys.length;
    const reversedObj = {};
    for (let i = 0; i < length; i++) {
      reversedObj[keys[i]] = values[length - i - 1];
    }
    reversedTokens[key] = reversedObj;
  });
  return reversedTokens;
}
export const tokensLight = reverseTokens(tokensDark);

// mui theme settings
export const themeSettings = (mode) => {
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            // palette values for dark mode
            primary: {
              ...tokensDark.primary,
              main: tokensDark.primary[100],
              light: tokensDark.primary[400],
            },
            secondary: {
              ...tokensDark.secondary,
              main: tokensDark.primary[300],
              light: 'white'
            },
            neutral: {
              ...tokensDark.grey,
              main: tokensDark.grey[500],
            },
            background: {
              default: tokensDark.primary[600],
              alt: tokensDark.primary[500],
              main: tokensDark.primary[600],
            },
          }
        : {
            // palette values for light mode
            primary: {
              ...tokensLight.primary[100],
              main: tokensDark.grey[500],
              light: tokensDark.grey[100],
            },
            secondary: {
              ...tokensLight.secondary,
              main: tokensDark.primary[400],
              light: 'black',
            },
            neutral: {
              ...tokensLight.secondary,
              main: tokensDark.primary[300],
            },
            background: {
              default: tokensDark.secondary[100],
              alt: tokensDark.grey[50],
              main: tokensDark.secondary[500],
              light:tokensDark.primary[100]
            },
          }),
    },
    typography: {
      fontFamily: ["Comfortaa", "cursive"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Comfortaa", "cursive"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Comfortaa", "cursive"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Comfortaa", "cursive"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Comfortaa", "cursive"].join(","),
        fontSize: 20,
      },
      h5: {
        fontFamily: ["Comfortaa", "cursive"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Comfortaa", "cursive"].join(","),
        fontSize: 14,
      },
    },
  };
};
